module.exports = __webpack_public_path__ + "img/payment-waiting-ovo.f84fdb2c.png";